// Import dependencies
import React from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";

import Post from "./Post/Post";
import useStyles from "./styles";

// Posts layout structure and design
const Posts = ({ setCurrentId }) => {
  // Fetches all posts from redux-store
  const posts = useSelector((state) => state.posts);

  //css styling
  const classes = useStyles();

  return !posts.length ? (
    //Load Circular Progress indicator if no posts
    <CircularProgress />
  ) : (
    <Grid
      className={classes.container}
      container
      alignItems="stretch"
      spacing={3}
    >
      {posts.map((post, index) => (
        <Grid key={index} item xs={12} sm={12} md={12}>
          <Post post={post} setCurrentId={setCurrentId} />
        </Grid>
      ))}
    </Grid>
  );
};

export default Posts;
